import { EventListItem } from 'model/modules/events/eventList';
import moment from 'moment';
import mapPaginationListFromApi from 'rtkQuery/sharespro/mapper/shared/mapPaginationListFromApi';

export const mapEventListItemFromApi = (
  resp: ApiEventListItem
): EventListItem => {
  return {
    id: resp.id,
    name: resp.name,
    preview: resp.preview.url ?? '',
    startDate: moment(resp.start_date, 'DD.MM.yyyy hh:mm:ss').toDate(),
    endDate: moment(resp.finish_date, 'DD.MM.yyyy hh:mm:ss').toDate(),
    location: resp.location,
    status: resp.status,
    subtitle: resp.subtitle,
  };
};

export const mapEventPaginationListFromApi = (
  resp: ApiPaginationListResponse<ApiEventListItem>
): PaginationList<EventListItem> => {
  return mapPaginationListFromApi<EventListItem, ApiEventListItem>(
    resp,
    mapEventListItemFromApi
  );
};
